<template>
  <div class="routing-header">
    <!--div class="title">ROUTING</div-->
    <table-search></table-search>
    <table-filter></table-filter>
  </div>
</template>

<script>
import TableFilter from './TableFilter'
import TableSearch from './TableSearch'

export default {
  name: 'routing-header',
  components: { TableFilter, TableSearch }
}
</script>

<style lang="scss" scoped>
.routing-header {
  padding: 0 20px 0 50px;
  height: 50px;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid rgba(0,0,0,0.15);

  & .title {
    font-weight: 700;
    font-size: 22px;
    color: #3F2975;
    display: inline-block;
    width: 120px;
    line-height: 22px;
  }

  & > * {
    height: 50px;
  }

  & input, & .select-input{
    display: inline-block;
    line-height: inherit;
  }

  & input {
    width: 40%;
    margin: 0;
    border-radius: 0;
    border-top: 0;
  }
}

@media only screen and (max-width: 430px) {
  .routing-header {
    padding: 0;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Routing/Header.vue